import { useEffect, useState } from 'react';

export function useAuditEvents(params) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		setLoading(true);
		const url = new URL( `${import.meta.env.VITE_APP_API_URL}/audit/events`, window.location.origin);
		Object.entries(params || {}).forEach(([k, v]) => {
			if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v));
		});
		fetch(url.toString())
			.then(r => r.json())
			.then(setData)
			.catch(setError)
			.finally(() => setLoading(false));
	}, [JSON.stringify(params)]);

	return { data, loading, error };
}
